import React, { useState } from "react";
import { Button, Collapse, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FilterListIcon from "@material-ui/icons/FilterList";

const useStyles = makeStyles((theme) => ({
  panel: {
    flex: "0 0 280px",
    width: 280,
    boxSizing: "border-box",
    borderLeft: "1px solid #d9d9d9",
    backgroundColor: "#fff",
    padding: theme.spacing(1, 1.5, 2),
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flex: "1 1 100%",
      width: "100%",
      borderLeft: "none",
      borderTop: "1px solid #d9d9d9",
    },
  },
  sectionHead: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "100%",
    minHeight: 40,
    padding: "0 4px",
    border: 0,
    background: "transparent",
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: "0.95rem",
    color: "#1a1a1a",
    textAlign: "left",
    borderRadius: 8,
    "&:hover": { backgroundColor: "#f0f0f0" },
  },
  sectionTitle: { flex: 1, display: "flex", alignItems: "center", gap: 6 },
  sectionBody: { padding: "4px 4px 12px 28px" },
  footer: { display: "flex", justifyContent: "flex-end", paddingTop: theme.spacing(1) },
}));

// Collapsible filter group: chevron + title (+ optional icon) + filter glyph.
export function FilterSection({ title, icon, defaultOpen = true, children }) {
  const classes = useStyles();
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <button type="button" className={classes.sectionHead} onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        {open ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
        <span className={classes.sectionTitle}>
          {icon}
          {title}
        </span>
        <FilterListIcon fontSize="small" style={{ color: "#555" }} />
      </button>
      <Collapse in={open} unmountOnExit>
        <div className={classes.sectionBody}>{children}</div>
      </Collapse>
    </div>
  );
}

// Right-hand filter panel. Put it beside the list/table, show it from a toolbar
// "Filters" button, and put one <FilterSection> per filterable field inside.
export default function FilterPanel({ title = "Filters", onReset, onApply, applyLabel = "Apply", children }) {
  const classes = useStyles();
  return (
    <aside className={classes.panel} aria-label={title}>
      {children}
      {(onReset || onApply) && (
        <div className={classes.footer}>
          {onReset && (
            <Button variant="outlined" onClick={onReset}>
              Reset
            </Button>
          )}
          {onApply && (
            <Button variant="contained" color="primary" onClick={onApply} style={{ marginLeft: 8 }}>
              {applyLabel}
            </Button>
          )}
        </div>
      )}
    </aside>
  );
}
